import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import Hero from "../components/home/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import TeamsBento from "../components/home/TeamsBento";
import HomeNews from "../components/home/HomeNews";
import HomeResults from "../components/home/HomeResults";
import HomeEvents from "../components/home/HomeEvents";
import HomePartners from "../components/home/HomePartners";
import { Reveal } from "../components/Reveal";

export default function Home() {
  return (
    <>
      <SEO />
      <Hero />
      <EditorialMarquee />
      <TeamsBento />
      <HomeNews />
      <HomeResults />
      <HomeEvents />
      <HomePartners />

      <section className="bg-rouge py-20 sm:py-28">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 flex flex-col lg:flex-row lg:items-center justify-between gap-10">
          <Reveal>
            <h2 className="font-heading uppercase font-semibold tracking-tighter leading-[0.95] text-white text-4xl sm:text-6xl">
              Envie de rouler<br />avec nous ?
            </h2>
            <p className="mt-4 text-white/80 max-w-lg">
              Coureur, coureuse, jeune, parent, bénévole ou partenaire : le club vous accueille. Contactez-nous.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/contact"
              data-testid="cta-contact"
              className="group inline-flex items-center gap-3 bg-navy text-white font-heading uppercase tracking-wider text-sm px-9 py-5 hover:bg-white hover:text-navy transition-[background-color,color] duration-300"
            >
              Nous contacter
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
